import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { AgendaNoteEntity, AgendaNoteInput } from './agenda-note.entity'

export class AgendaNotesRepository extends BaseRepository<AgendaNoteEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/' + 'agenda-notes', token, cache)
    }

    private endpoint(path: string = '') {
        return this.config.schedulerApi + '/agenda-notes' + path + '?token=' + this.resolvedToken
    }

    private handle({ json, statusCode, message }) {
        if (String(statusCode).substring(0, 1) === '2') return json
        if (json) throw json
        throw message
    }

    // minhas + públicas da equipe que valem de from a to ('AAAA-MM-DD'), incluindo minhas tarefas esquecidas
    async findForRange(from: string, to: string): Promise<AgendaNoteEntity[]> {
        return this.handle(await this.request.get(this.endpoint() + '&from=' + from + '&to=' + to))
    }

    async createNote(input: AgendaNoteInput & { date: string }): Promise<AgendaNoteEntity> {
        return this.handle(await this.request.post(this.endpoint(), input))
    }

    async updateNote(agendaNoteId: string, input: Partial<AgendaNoteInput>): Promise<AgendaNoteEntity> {
        return this.handle(await this.request.patch(this.endpoint('/' + agendaNoteId), input))
    }

    async removeNote(agendaNoteId: string) {
        return this.handle(await this.request.delete(this.endpoint('/' + agendaNoteId)))
    }

    // "Excluir apenas esta"
    async skipDay(agendaNoteId: string, day: string): Promise<AgendaNoteEntity> {
        return this.handle(await this.request.post(this.endpoint('/' + agendaNoteId + '/skip'), { day }))
    }

    // "Excluir esta e as futuras"
    async endBeforeDay(agendaNoteId: string, day: string): Promise<AgendaNoteEntity> {
        return this.handle(await this.request.post(this.endpoint('/' + agendaNoteId + '/until'), { day }))
    }

    async complete(agendaNoteId: string, day: string): Promise<AgendaNoteEntity> {
        return this.handle(await this.request.post(this.endpoint('/' + agendaNoteId + '/completions'), { day }))
    }

    async uncomplete(agendaNoteId: string, day: string): Promise<AgendaNoteEntity> {
        return this.handle(await this.request.delete(this.endpoint('/' + agendaNoteId + '/completions/' + day)))
    }
}
